'use client';
import { Button, message, Modal, Radio } from 'antd';
import { Input } from 'antd/lib';
import { GlobalContext } from 'context';
import { API } from 'data';
import { useContext, useState } from 'react';
import { RestAPI, useAsyncClick } from 'scripts';
import { ReportProblemEnum } from 'types';
import { __ReportProblemData } from '../postData.data';
import styles from './report.module.scss';
import { TbChevronLeft, TbInfoCircle, TbX } from 'react-icons/tb';
import { __PostSpamModalPropsType } from './report.type';

export default function PostReportComp(props: __PostSpamModalPropsType) {
    const { profile } = useContext(GlobalContext);
    const [problem, setProblem] = useState<ReportProblemEnum>(ReportProblemEnum.fraud);
    const [otherDescription, setOtherDescription] = useState('');

    const onOkHandler = useAsyncClick(() => {
        return new Promise((resolve) => {
            if (props.isReported) {
                resolve(false);
                return;
            }
            if (!profile) {
                message.error('لطفا برای ثبت گزارش وارد حساب خود شوید.');
                resolve(false);
                return;
            }
            if (problem === ReportProblemEnum.other && !otherDescription) {
                message.error('لطفا توضیحات گزارش خودرا پرکنید.');
                resolve(false);
                return;
            }
            RestAPI.post(API.report.add, { problem: [problem], description: otherDescription, post: props.postID })
                .then(() => {
                    message.success('گزارش شما با موفقیت ثبت شد.');
                    resolve(true);
                })
                .catch(() => {
                    message.error('عملیات با خطا مواجه شد لطفا بعدا دوباره تلاش کنید.');
                    resolve(false);
                });
            props.setOpen(false);
        });
    });

    return (
        <>
            <div
                onClick={() => {
                    if (props.isOwner) message.warning('این آگهی متعلق به شماست و نمیتوانید آگهی خود را گزارش کنید');
                    else if (!props.isReported) props.setOpen(true);
                }}
                className={`${styles['spam']} ${props.isReported ? styles['is-reported'] : ''} 
                            justify-content-between center-content-y pointer`}
            >
                <div className={`center-content-y`}>
                    <TbInfoCircle size={18} className="t-l-black1 t-d-gray2" />
                    <p className="t-p2 t-400 t-l-black1 t-d-gray2">
                        {props.isReported ? 'گزارش شده' : 'گزارش تخلف آگهی'}
                    </p>
                </div>
                {!props.isReported ? <TbChevronLeft size={18} className="t-l-black1 t-d-gray2" /> : null}
            </div>
            <Modal
                width={400}
                open={props.open ? true : false}
                onCancel={() => props.setOpen(false)}
                closeIcon={null}
                footer={
                    <Button {...onOkHandler} className={`${styles['btn-submit']}`} disabled={props.isReported}>
                        {props.isReported ? 'گزارش شده' : 'تایید'}
                    </Button>
                }
            >
                <div className={`${styles['spam-content']}`}>
                    <div className={`${styles['header']} center-content-y justify-content-between`}>
                        <p className="t-h3 t-500 t-d-gray3-i">گزارش آگهی</p>
                        <Button type="primary" icon={<TbX size={20} />} onClick={() => props.setOpen(false)} />
                    </div>
                    <div className="flex-column center-content-x g-3 mt-3">
                        <p className="t-h2 t-600 t-d-gray3-i">مشکل آگهی چیست؟</p>
                        <Radio.Group
                            name="radiogroup"
                            className="flex-column center-content-x g-2"
                            defaultValue={1}
                            options={__ReportProblemData.map((i) => ({ label: i.title, value: i.id }))}
                            onChange={(e) => setProblem(e.target.value)}
                        />
                        {problem === ReportProblemEnum.other ? (
                            <Input.TextArea
                                value={otherDescription}
                                onChange={(e) => setOtherDescription(e.target.value)}
                                placeholder="توضیحات..."
                            />
                        ) : null}
                    </div>
                </div>
            </Modal>
        </>
    );
}
